import { gql } from '@/__generated__';
import { useQueryTypeahead } from '@/components/use-query-typeahead';

const StreamDeckTypeaheadStreamsQuery = gql(`
  query StreamDeckTypeaheadStreamsQuery($query: String!, $limit: Int = 10, $offset: Int = 0, $followingFirst: Boolean = true, $paidFirst: Boolean = true, $polymatcherEnabled: Boolean) {
  streamsTypeaheadQuery: typeahead(input: {text: $query, limit: $limit, offset: $offset, type: [Stream], followingFirst: $followingFirst, paidFirst: $paidFirst, polymatcherEnabled: $polymatcherEnabled}) {
      streams {
        id
        ...StreamCardFragment
        canAddToStreamDeck
        polymatcherEnabled
        accessAllowed
        following
        customTargetsData {
          ...CustomTargetsDataFragment
        }
      }
      offset
    }
  }
  `);

export const useTypeaheadStreams = (
  variables?: Record<string, unknown>,
  skip = false,
) => {
  const { data, ...rest } = useQueryTypeahead(
    StreamDeckTypeaheadStreamsQuery,
    false,
    variables,
    skip,
  );
  return {
    streams: data?.streamsTypeaheadQuery.streams,
    ...rest,
  };
};
